module.exports = __webpack_public_path__ + "static/media/edit.524ea8e1.svg";